import { useCallback } from 'react';
import { RootState } from '../store';
import * as QuestoesActions from '../store/Questoes.reducer';
import { useAppDispatch, useAppSelector } from './hooks';

export default function useQuestoes() {
  const dispatch = useAppDispatch();

  const questoes = useAppSelector(
    (state: RootState) => state.questoes.list
  );

  const fetching = useAppSelector(
    (state: RootState) => state.questoes.fetching
  );

  const buscarTodasAsQuestoes = useCallback(() => {
    dispatch(QuestoesActions.getTodasAsQuestoes());
  }, [dispatch]);

  return {
    buscarTodasAsQuestoes,
    questoes,
    fetching,
  };
}
